import React, { Component } from 'react';
import * as styled from '../../styles/style';
import { validString, validEmail } from '../../helpers/check-required-fields';

class Newsletter extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      firstname: '',
      lastname: '',
    };
  }

  render() {
    const valid = validString(this.state.firstname) && validString(this.state.lastname) && validEmail(this.state.email)
    return (
      <styled.Main>
        <p style={{marginBottom: '25px'}}>Please sign up for our newsletter to stay up-to-date with all On the Table news and events in the future.</p>
        <form action="https://onthetablebc.us18.list-manage.com/subscribe/post?u=cae4c44006a6ca32349b0201b&amp;id=04008cffea" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_parent" noValidate>
          <div id="mc_embed_signup_scroll">
            <styled.FormRow>
              <styled.HalfWidthFieldGroup>
                <styled.Label required={true} htmlFor="mce-FNAME">First Name</styled.Label>
                <styled.FormField public type="text" value={this.state.firstname} name="FNAME" className="required" id="mce-FNAME" placeholder="" onChange={ (e)=>{this.setState({firstname: e.target.value});} } />
              </styled.HalfWidthFieldGroup>
              <styled.HalfWidthFieldGroup>
                <styled.Label required={true} htmlFor="mce-LNAME">Last Name</styled.Label>
                <styled.FormField public type="text" value={this.state.lastname} name="LNAME" className="required" id="mce-LNAME" placeholder="" onChange={ (e)=>{this.setState({lastname: e.target.value});} } />
              </styled.HalfWidthFieldGroup>
            </styled.FormRow>
            <styled.FormRow>
              <styled.FullWidthFieldGroup>
                <styled.Label required={true} htmlFor="mce-EMAIL">Email Address</styled.Label>
                <styled.FormField public type="email" value={this.state.email} name="EMAIL" className="required email" id="mce-EMAIL" placeholder="" onChange={ (e)=>{this.setState({email: e.target.value});} } />
              </styled.FullWidthFieldGroup>
            </styled.FormRow>
            <div id="mce-responses" className="clear">
              <div className="response" id="mce-error-response" style={{"display": "none"}}></div>
              <div className="response" id="mce-success-response" style={{"display" :"none"}}></div>
            </div>
            <div style={{"position": "absolute", "left": "-5000px"}} aria-hidden="true"><input type="text" name="b_cae4c44006a6ca32349b0201b_04008cffea" tabIndex="-1" value="" /></div>
            <styled.ButtonGroup>
              {/*<styled.ButtonLink secondary="true" to="/host/welcome">&lt; Go back</styled.ButtonLink>*/}
              <styled.Button disabled={!valid} type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="btn newsletter_submit_btn" />
            </styled.ButtonGroup>
            <styled.Disclaimer>Your email address will not be shared with a third party and you can unsubscribe from updates at any time.</styled.Disclaimer>
          </div>
        </form>
      </styled.Main>
    )
  }
}

export default Newsletter
